<template>
  <el-dialog
    title="标签管理"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="140px">
        <el-form-item label="标签类型">
          <el-select
            style="width: 356px;"
            v-model="formInline.ghEventTypeId"
            placeholder="请选择"
            :disabled="formInline.id ? true : false"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="`${item.tagType}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签名称" prop="tagName">
          <el-input
            style="width: 356px;"
            v-model="formInline.tagName"
            placeholder="标签名称"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" class="button-info" @click="eventEditFun">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { userTagupdate, userTagaddTag } from "@/api/base.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },

    typeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dataRadio: "1",
      mapVisible: false,
      formInline: {
        ghEventTypeId: "",
        state: "",
        tagName: "",
        zrrlx: "街道人员",
        id: "",
        tjDeptId: "",
        extendGzUseRuleTable: "",
        dayTimes: "",
        ksWeekTimes: "",
        extendRangeMetre: null,
        extendLongitude: null,
        extendLatitude: null,
        extendAddress: null
      },
      // zrrlxOptions: [],
      extendTimeRangeList: [
        {
          time: null
        }
      ],
      deptList: [],
      useRuleList: [],
      curSource: {
        text: "",
        value: ""
      },
      picFilesJson: [],

    };
  },
  created() {
    this.formInline = JSON.parse(JSON.stringify(this.curItem));
  },
  methods: {
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
    async eventEditFun() {
      if (!this.formInline.tagName) return this.$message.error('请输入标签名称');
      let params = {
        pid: this.formInline.ghEventTypeId,
        tagName: this.formInline.tagName,
        tagType: this.typeList.find(item => item.id == this.formInline.ghEventTypeId).tagType,
        id: this.formInline.id,
      };
      const res = await (this.formInline.id ? userTagupdate(params) : userTagaddTag(params));
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/ .button-info {
  background: #0054FE !important;
}
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}
/deep/.el-upload__input {
  display: none;
}
/deep/.avatar-uploader {
  display: flex;
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/personLabel/components/issuesDialog.vue